export enum KnowledgeBaseStatus{
    PENDING = 'PENDING',
    READY = 'READY'
}